import { NegativeEmotions } from "../../../SubjectData/BasicWords/Emotions.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function NegativeEmotionsDeck() {


 return (
    <>
      <HeaderNav GoBack_to="/EmotionsNav" />
      <FlashcardInterface deckData={NegativeEmotions} title="Negative Emotions" />
    </>
)}